





































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator/lib/vue-property-decorator';
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import StatusPicker from "@/view/shared-components/StatusPicker.vue";
import HoldTicket from "@/domainObjects/hold/HoldTicket";
import TicketService from "@/services/TicketService";
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";
import {mapGetters} from "vuex";
import Disposition from "@/domainObjects/hold/Disposition";

@Component({
    components: {LoadingIndicator, StatusPicker, PlantPicker},
    computed: {
        ...mapGetters(['getGroups'])
    }
})
export default class HoldSAPDetails extends Vue {
    @Prop({required: true}) holdTicket!: HoldTicket;
    @Prop({required: true}) type!: String;

    private errorMessage: String = "";
    private orderLoading: boolean = false;
    private getGroups!: string[];

    @Watch('holdTicket', { immediate: true, deep: true})
    onPropertyChanged(value:HoldTicket, oldvalue: HoldTicket){
        this.errorMessage = "";
    }

    selectPlant(value) {
        this.holdTicket.plant = value;
        this.holdTicket.plantCode = value.code;
    }

    selectStatus(value) {
        this.holdTicket.status = value;
        this.holdTicket.statusId = value.id;
    }

    closeCoreReqsMet(): boolean {
      if (this.holdTicket.dispositionBy && this.holdTicket.dispositionBy.length > 0 &&
          this.holdTicket.dispositionDate &&
          this.holdTicket.responsibleForAction && this.holdTicket.responsibleForAction.length > 0 &&
          this.holdTicket.dispositionComments && this.holdTicket.dispositionComments.length > 0) {
        return true
      }
      return false
    }

    closeAcceptAsIsMeetsReq(): boolean {
      if (this.closeCoreReqsMet() &&
      this.holdTicket.disposition.id === Disposition.ACCEPT_AS_IS && this.holdTicket.attachmentCount > 0) {
        return true
      }
      return false
    }

    closeMeetsSpecMeetsReq(): boolean {
      if (this.closeCoreReqsMet() &&
      this.holdTicket.disposition.id === Disposition.MEETS_SPEC) {
        return true
      }
      return false
    }

    disableStatusChange(){
        if (
            this.closeAcceptAsIsMeetsReq() ||
            this.closeMeetsSpecMeetsReq() ||
            this.holdTicket.status.desc === 'Closed' && this.getGroups.includes('admin')
            ) {
            return false
        }
        return true
    }

    editAll() {
        this.holdTicket.disableEditMaterial = !this.holdTicket.disableEditMaterial;
    }

    getOrder(){
        this.orderLoading = true;
        TicketService.getMaterialData(this.holdTicket.productionOrderNum).then((response) => {
            if (response.data) {
              if(response.data.MaterialDataList) {
                const materialData = response.data.MaterialDataList[0];
                this.holdTicket.materialDesc = materialData.MaterialDescription;
                this.holdTicket.materialNumber = materialData.MaterialNumber;
                this.holdTicket.lineItem = materialData.SalesOrderItem;
                if (materialData.SalesOrderNo === "") {
                  this.holdTicket.salesOrderNumber = "N/A"
                } else {
                  this.holdTicket.salesOrderNumber = materialData.SalesOrderNo;
                }
              } else {
                this.errorMessage = "prod order not found"
              }
              this.orderLoading = false;
            }
        }).catch((error) => {
            this.errorMessage = "error";
            this.orderLoading = false;
        })
    }
}
